import { getJson } from './ServiceHelperMethods'

class ModelTypeService {

    static async getDataTypes() {
        return await getJson(`datatypes`);
    }
}

export default ModelTypeService;